<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="menu-hamburger">
<g id="Vector">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3 17.3334C3 17.0572 3.22386 16.8334 3.5 16.8334H20.5C20.7761 16.8334 21 17.0572 21 17.3334C21 17.6095 20.7761 17.8334 20.5 17.8334H3.5C3.22386 17.8334 3 17.6095 3 17.3334Z" fill="#212328"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3 12C3 11.7239 3.22386 11.5 3.5 11.5H20.5C20.7761 11.5 21 11.7239 21 12C21 12.2762 20.7761 12.5 20.5 12.5H3.5C3.22386 12.5 3 12.2762 3 12Z" fill="#212328"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3 6.66669C3 6.39054 3.22386 6.16669 3.5 6.16669H20.5C20.7761 6.16669 21 6.39054 21 6.66669C21 6.94283 20.7761 7.16669 20.5 7.16669H3.5C3.22386 7.16669 3 6.94283 3 6.66669Z" fill="#212328"/>
</g>
</g>
</svg>
